import React from 'react'
import { ContactContainer, ContactH1, ContactH2, ContactH3, ContactH4 } from './ContactElements';
//import Alert from '@material-ui/core';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import TextScrambler from 'react-scramble-text'
import 'react-scramble-text/dist/index.css'

function Contact() {
    const Mailto = ({ email, subject = '', body = '', children }) => {
        let params = subject || body ? '?' : '';
        if (subject) params += `subject=${encodeURIComponent(subject)}`;
        if (body) params += `${subject ? '&' : ''}body=${encodeURIComponent(body)}`;
      
        return <a href={`mailto:${email}${params}`}>{children}</a>;
      };
    const phrases = ["Contact Me","Get In Touch"];
    return (
        
            <ContactContainer id="contact">
                <ContactH1>
                <TextScrambler phrases={phrases}
                          speed={30}
                          pauseTime={850}/>{''}
                </ContactH1>
                <ContactH2>
                I'm available for freelance work. <br/>
                Drop me a message!
                </ContactH2>
                <CopyToClipboard text="kovacsbalinthunor53@gmail.com">
                    <ContactH3> 
                    <Mailto email="kovacsbalinthunor53@gmail.com" subject="Hello & Welcome" body="Let's talk about some bussiness!">
                        <p >kovacsbalinthunor53@gmail.com</p>
                        </Mailto>
                    </ContactH3>
                </CopyToClipboard>
                <ContactH4>{'/*'}Click on the email adress to copy!{'*/'}</ContactH4>
            </ContactContainer>
            
        
    )
}

export default Contact
